export default "__VITE_ASSET__DmVV2djh__"